var exports = {
  "x": "truncate__7Pto_1",
};

module.exports = exports;
